import { render, staticRenderFns } from "./ModalPrevisto.vue?vue&type=template&id=36a2e2da&"
import script from "./ModalPrevisto.vue?vue&type=script&lang=js&"
export * from "./ModalPrevisto.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrevisto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports